var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83519 13.6667H4.66683V10.3333C4.66683 5.73096 8.39779 2 13.0002 2C17.6025 2 21.3335 5.73096 21.3335 10.3333V13.6667H21.1651M13.0002 20.3333V23.6667M24.6668 22C24.6668 28.4433 19.4435 33.6667 13.0002 33.6667C6.55684 33.6667 1.3335 28.4433 1.3335 22C1.3335 15.5567 6.55684 10.3333 13.0002 10.3333C19.4435 10.3333 24.6668 15.5567 24.6668 22Z",
    stroke: "#278DEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.df7e34c47443112a744ef97a6395a6f7.svg";
export { ForwardRef as ReactComponent };